import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, MenuItem, Card, CardContent } from "@mui/material";
import api from "../../api/api";

export default function LeaveApply() {

  const [types, setTypes] = useState([]);
  const [form, setForm] = useState({
    leave_type_id: "",
    start_date: "",
    end_date: "",
    reason: "",
    half_day: false
  });

  useEffect(() => {
    loadTypes();
  }, []);

  const loadTypes = async () => {
    const res = await api.get("/leave-types");
    setTypes(res.data);
  };

  const handleSubmit = async () => {
    try {
      await api.post("/leaves/apply", form);
      alert("Leave applied successfully");
      setForm({
        leave_type_id: "",
        start_date: "",
        end_date: "",
        reason: "",
        half_day: false
      });
    } catch (err) {
      alert(err.response?.data?.error || "Error applying leave");
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>Apply Leave</Typography>

      <Card>
        <CardContent>

          <TextField
            select
            fullWidth
            label="Leave Type"
            value={form.leave_type_id}
            onChange={(e)=>setForm({...form,leave_type_id:e.target.value})}
            sx={{mb:2}}
          >
            {types.map(t=>(
              <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
            ))}
          </TextField>

          <TextField
            type="date"
            fullWidth
            label="Start Date"
            InputLabelProps={{shrink:true}}
            value={form.start_date}
            onChange={(e)=>setForm({...form,start_date:e.target.value})}
            sx={{mb:2}}
          />

          <TextField
            type="date"
            fullWidth
            label="End Date"
            InputLabelProps={{shrink:true}}
            value={form.end_date}
            onChange={(e)=>setForm({...form,end_date:e.target.value})}
            sx={{mb:2}}
          />

          <TextField
            multiline
            rows={3}
            fullWidth
            label="Reason"
            value={form.reason}
            onChange={(e)=>setForm({...form,reason:e.target.value})}
            sx={{mb:2}}
          />

          <Button variant="contained" onClick={handleSubmit}>
            Apply Leave
          </Button>

        </CardContent>
      </Card>
    </Box>
  );
}